<template>
  <el-popover placement="bottom-start" trigger="click" width="240" popper-class="media-rejection-popover">
    <div class="popover-content">
      <el-tree ref="tree" :data="treeData" node-key="key" :render-content="renderNode" />
    </div>

    <el-input
      slot="reference"
      :value="displayText"
      readonly
      placeholder="请选择平台及拒审次数"
      class="reference-input"
      @mouseenter.native="showClear = true"
      @mouseleave.native="showClear = false"
    >
      <i
        slot="suffix"
        class="el-input__icon"
        :class="showClear && displayText ? 'el-icon-circle-close' : 'el-icon-arrow-down'"
        @click.stop="handleIconClick"
      />
    </el-input>
  </el-popover>
</template>

<script>
export default {
  name: 'TreeRadioSelector',

  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showClear: false
    }
  },

  computed: {
    treeData() {
      return this.options.map((platform) => ({
        key: `p-${platform.value}`,
        type: 'platform',
        label: platform.label,
        value: platform.value,
        children: platform.children.map((child) => ({
          key: `c-${platform.value}-${child.value}`,
          type: 'child',
          label: child.label,
          value: child.value,
          parent: platform.value
        }))
      }))
    },

    displayText() {
      if (!this.value.length) return ''
      return this.value
        .map((v) => {
          const p = this.options.find((o) => o.value === v.platform)
          const c = p?.children.find((c) => c.value === v.rejectCount)
          return p && c ? `${p.label}：${c.label}` : ''
        })
        .filter(Boolean)
        .join('，')
    }
  },

  methods: {
    renderNode(h, { node, data }) {
      // 一级：纯文本展示
      if (data.type === 'platform') {
        const hasSelection = this.value.some((v) => v.platform === data.value)
        const color = hasSelection ? '#409eff' : '#303133'

        return <span style={{ fontWeight: 500, color, cursor: 'default' }}>{data.label}</span>
      }

      // 二级：checkbox (作为单选使用)
      if (data.type === 'child') {
        const current = this.value.find((v) => v.platform === data.parent)
        // 判断是否选中：父级存在且rejectCount匹配
        const isChecked = !!(current && current.rejectCount === data.value)
        return (
          <span style="padding-left: 12px;">
            <el-checkbox value={isChecked} onChange={() => this.selectChild(data.parent, data.value)}>
              {data.label}
            </el-checkbox>
          </span>
        )
      }
    },

    togglePlatform(platform, checked) {
      let next = [...this.value]

      if (checked) {
        if (!next.some((v) => v.platform === platform)) {
          // 选中父级时，默认不选中任何子级
          next.push({ platform, rejectCount: null })
        }
      } else {
        next = next.filter((v) => v.platform !== platform)
      }

      this.emit(next)
    },

    selectChild(platform, rejectCount) {
      const index = this.value.findIndex((v) => v.platform === platform)
      const next = [...this.value]

      if (index > -1) {
        // 如果点击的是已选中的项，则取消选中（移除整个条目）
        if (next[index].rejectCount === rejectCount) {
          next.splice(index, 1)
        } else {
          // 否则更新子级选择（实现单选替换）
          next[index] = { ...next[index], rejectCount }
        }
      } else {
        // 父级未存在，自动勾选父级并选择子级
        next.push({ platform, rejectCount })
      }

      this.emit(next)
    },

    emit(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },

    handleIconClick() {
      if (this.showClear && this.displayText) {
        this.emit([])
      }
    }
  }
}
</script>

<style lang="scss">
.media-rejection-popover {
  padding: 0;

  .popover-content {
    height: 270px;
    overflow-y: auto;
    padding: 12px;
  }

  // 选中状态样式增强
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
    font-weight: 500;
  }
}

.reference-input {
  .el-icon-circle-close {
    cursor: pointer;
    color: #c0c4cc;
    &:hover {
      color: #909399;
    }
  }
}
</style>
